/**
 * Created by asiulik on 15.11.2017.
 */
define(['jquery'], function($){

    function SubHeader(){}

    SubHeader.prototype.init = function(){

        var _this = this;

        this.$subheader = $('#subheader');
        this.$subheaderSections = $('#sectionHeader');
        this.$subheaderToggler = $('#subheader__category')

        this.$subheaderToggler.on({
            click: function(e){

                e.preventDefault();
                _this.$subheader.toggleClass('subheader--opened');
                _this.$subheaderSections.toggleClass('subheader--opened');

            }
        })

    };

    return SubHeader;

});


// WEBPACK FOOTER //
// ./Private/Scripts/modules/header/subheader.js